// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"8503fb75","348":"53441f0e","480":"57bf6062"}[chunkId] + ".chunk.css";
};